import React from "react";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import { CloseIcon } from "icons";
import HYLYLogo from "images/hylyAI.svg";

const CloseButton = ({ classes, onClose }) => {
  return (
    <div className={classes.closeButton} onClick={onClose}>
      <CloseIcon />
    </div>
  );
};

const DialogTitle = ({ classes, title, onClose, type }) => {
  if (type === "intro") {
    return (
      <MuiDialogTitle disableTypography className={classes.customHeaderRoot}>
        <CloseButton classes={classes} onClose={onClose} />
      </MuiDialogTitle>
    );
  }
  return (
    <MuiDialogTitle disableTypography className={classes.headerRoot}>
      <div className={classes.headerLeft}>
        <img className={classes.logoClass} src={HYLYLogo} alt="hylyAi" />
        {title}
      </div>
      {onClose ? <CloseButton classes={classes} onClose={onClose} /> : null}
    </MuiDialogTitle>
  );
};
export default DialogTitle;